var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['d-flex', _vm.alignClass]},[_c('v-btn',_vm._g(_vm._b({class:[
      'button-widget px-12 font-weight-regular text-none text-body-1',
      _vm.secondary && 'grey--text text--darken-4' ],attrs:{"color":!_vm.secondary ? 'primary' : 'secondary',"height":"40px","depressed":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }